// Produkt-Datenbank nach Hersteller

export const products = {
  // HAGER Produkte
  hager: {
    sls: [
      { id: 'HTN125E', name: 'SLS-Schalter 1P 25A E-Char', nennstrom: '25', pole: '1', bauform: 'Sammelschiene' },
      { id: 'HTN132E', name: 'SLS-Schalter 1P 32A E-Char', nennstrom: '32', pole: '1', bauform: 'Sammelschiene' },
      { id: 'HTN135E', name: 'SLS-Schalter 1P 35A E-Char', nennstrom: '35', pole: '1', bauform: 'Sammelschiene' },
      { id: 'HTN140E', name: 'SLS-Schalter 1P 40A E-Char', nennstrom: '40', pole: '1', bauform: 'Sammelschiene' },
      { id: 'HTN150E', name: 'SLS-Schalter 1P 50A E-Char', nennstrom: '50', pole: '1', bauform: 'Sammelschiene' },
      { id: 'HTN163E', name: 'SLS-Schalter 1P 63A E-Char', nennstrom: '63', pole: '1', bauform: 'Sammelschiene' },
      { id: 'HTN325E', name: 'SLS-Schalter 3P 25A E-Char', nennstrom: '25', pole: '3', bauform: 'Sammelschiene' },
      { id: 'HTN332E', name: 'SLS-Schalter 3P 32A E-Char', nennstrom: '32', pole: '3', bauform: 'Sammelschiene' },
      { id: 'HTN335E', name: 'SLS-Schalter 3P 35A E-Char', nennstrom: '35', pole: '3', bauform: 'Sammelschiene' },
      { id: 'HTN340E', name: 'SLS-Schalter 3P 40A E-Char', nennstrom: '40', pole: '3', bauform: 'Sammelschiene' },
      { id: 'HTN350E', name: 'SLS-Schalter 3P 50A E-Char', nennstrom: '50', pole: '3', bauform: 'Sammelschiene' },
      { id: 'HTN363E', name: 'SLS-Schalter 3P 63A E-Char', nennstrom: '63', pole: '3', bauform: 'Sammelschiene' }
    ],
    ls: [
      { id: 'MBN106', name: 'LS-Schalter 1P B6A', nennstrom: '6', charakteristik: 'B', pole: '1' },
      { id: 'MBN110', name: 'LS-Schalter 1P B10A', nennstrom: '10', charakteristik: 'B', pole: '1' },
      { id: 'MBN113', name: 'LS-Schalter 1P B13A', nennstrom: '13', charakteristik: 'B', pole: '1' },
      { id: 'MBN116', name: 'LS-Schalter 1P B16A', nennstrom: '16', charakteristik: 'B', pole: '1' },
      { id: 'MBN120', name: 'LS-Schalter 1P B20A', nennstrom: '20', charakteristik: 'B', pole: '1' },
      { id: 'MBN125', name: 'LS-Schalter 1P B25A', nennstrom: '25', charakteristik: 'B', pole: '1' },
      { id: 'MBN132', name: 'LS-Schalter 1P B32A', nennstrom: '32', charakteristik: 'B', pole: '1' },
      { id: 'MCN106', name: 'LS-Schalter 1P C6A', nennstrom: '6', charakteristik: 'C', pole: '1' },
      { id: 'MCN110', name: 'LS-Schalter 1P C10A', nennstrom: '10', charakteristik: 'C', pole: '1' },
      { id: 'MCN116', name: 'LS-Schalter 1P C16A', nennstrom: '16', charakteristik: 'C', pole: '1' },
      { id: 'MCN120', name: 'LS-Schalter 1P C20A', nennstrom: '20', charakteristik: 'C', pole: '1' },
      { id: 'MCN125', name: 'LS-Schalter 1P C25A', nennstrom: '25', charakteristik: 'C', pole: '1' },
      { id: 'MCN132', name: 'LS-Schalter 1P C32A', nennstrom: '32', charakteristik: 'C', pole: '1' },
      { id: 'MBN306', name: 'LS-Schalter 3P B6A', nennstrom: '6', charakteristik: 'B', pole: '3' },
      { id: 'MBN310', name: 'LS-Schalter 3P B10A', nennstrom: '10', charakteristik: 'B', pole: '3' },
      { id: 'MBN316', name: 'LS-Schalter 3P B16A', nennstrom: '16', charakteristik: 'B', pole: '3' },
      { id: 'MBN320', name: 'LS-Schalter 3P B20A', nennstrom: '20', charakteristik: 'B', pole: '3' },
      { id: 'MBN325', name: 'LS-Schalter 3P B25A', nennstrom: '25', charakteristik: 'B', pole: '3' },
      { id: 'MBN332', name: 'LS-Schalter 3P B32A', nennstrom: '32', charakteristik: 'B', pole: '3' }
    ],
    rcd: [
      { id: 'CDA225D', name: 'FI-Schalter 2P 25A 30mA Typ A', nennstrom: '25', fehlerstrom: '30', pole: '2', typ: 'A' },
      { id: 'CDA240D', name: 'FI-Schalter 2P 40A 30mA Typ A', nennstrom: '40', fehlerstrom: '30', pole: '2', typ: 'A' },
      { id: 'CDA263D', name: 'FI-Schalter 2P 63A 30mA Typ A', nennstrom: '63', fehlerstrom: '30', pole: '2', typ: 'A' },
      { id: 'CDA425D', name: 'FI-Schalter 4P 25A 30mA Typ A', nennstrom: '25', fehlerstrom: '30', pole: '4', typ: 'A' },
      { id: 'CDA440D', name: 'FI-Schalter 4P 40A 30mA Typ A', nennstrom: '40', fehlerstrom: '30', pole: '4', typ: 'A' },
      { id: 'CDA463D', name: 'FI-Schalter 4P 63A 30mA Typ A', nennstrom: '63', fehlerstrom: '30', pole: '4', typ: 'A' },
      { id: 'CDA480D', name: 'FI-Schalter 4P 80A 30mA Typ A', nennstrom: '80', fehlerstrom: '30', pole: '4', typ: 'A' },
      { id: 'CFA425D', name: 'FI-Schalter 4P 25A 30mA Typ F', nennstrom: '25', fehlerstrom: '30', pole: '4', typ: 'F' },
      { id: 'CFA440D', name: 'FI-Schalter 4P 40A 30mA Typ F', nennstrom: '40', fehlerstrom: '30', pole: '4', typ: 'F' },
      { id: 'CFA463D', name: 'FI-Schalter 4P 63A 30mA Typ F', nennstrom: '63', fehlerstrom: '30', pole: '4', typ: 'F' }
    ],
    sammelschiene: [
      { id: 'KDN363A', name: 'Phasenschiene 3P 63A 12TE', pole: '3', nennstrom: '63', laenge: '12' },
      { id: 'KDN363B', name: 'Phasenschiene 3P 63A 24TE', pole: '3', nennstrom: '63', laenge: '24' },
      { id: 'KDN363C', name: 'Phasenschiene 3P 63A 56TE', pole: '3', nennstrom: '63', laenge: '56' },
      { id: 'KDN380A', name: 'Phasenschiene 3P 80A 12TE', pole: '3', nennstrom: '80', laenge: '12' }
    ]
  },

  // SCHRACK Produkte
  schrack: {
    rcd: [
      { id: 'AR002030', name: 'FI-Schalter 2P 25A 30mA Typ A', nennstrom: '25', fehlerstrom: '30', pole: '2', typ: 'A' },
      { id: 'AR004030', name: 'FI-Schalter 2P 40A 30mA Typ A', nennstrom: '40', fehlerstrom: '30', pole: '2', typ: 'A' },
      { id: 'AR006330', name: 'FI-Schalter 2P 63A 30mA Typ A', nennstrom: '63', fehlerstrom: '30', pole: '2', typ: 'A' },
      { id: 'AR402530', name: 'FI-Schalter 4P 25A 30mA Typ A', nennstrom: '25', fehlerstrom: '30', pole: '4', typ: 'A' },
      { id: 'AR404030', name: 'FI-Schalter 4P 40A 30mA Typ A', nennstrom: '40', fehlerstrom: '30', pole: '4', typ: 'A' },
      { id: 'AR406330', name: 'FI-Schalter 4P 63A 30mA Typ A', nennstrom: '63', fehlerstrom: '30', pole: '4', typ: 'A' }
    ],
    rcbo: [
      { id: 'BO617506', name: 'FI/LS B6A 30mA 1+N', nennstrom: '6', fehlerstrom: '30', charakteristik: 'B', pole: '1+N' },
      { id: 'BO617510', name: 'FI/LS B10A 30mA 1+N', nennstrom: '10', fehlerstrom: '30', charakteristik: 'B', pole: '1+N' },
      { id: 'BO617513', name: 'FI/LS B13A 30mA 1+N', nennstrom: '13', fehlerstrom: '30', charakteristik: 'B', pole: '1+N' },
      { id: 'BO617516', name: 'FI/LS B16A 30mA 1+N', nennstrom: '16', fehlerstrom: '30', charakteristik: 'B', pole: '1+N' },
      { id: 'BO617520', name: 'FI/LS B20A 30mA 1+N', nennstrom: '20', fehlerstrom: '30', charakteristik: 'B', pole: '1+N' },
      { id: 'BO617525', name: 'FI/LS B25A 30mA 1+N', nennstrom: '25', fehlerstrom: '30', charakteristik: 'B', pole: '1+N' },
      { id: 'BO617532', name: 'FI/LS B32A 30mA 1+N', nennstrom: '32', fehlerstrom: '30', charakteristik: 'B', pole: '1+N' },
      { id: 'CO617516', name: 'FI/LS C16A 30mA 1+N', nennstrom: '16', fehlerstrom: '30', charakteristik: 'C', pole: '1+N' },
      { id: 'CO617520', name: 'FI/LS C20A 30mA 1+N', nennstrom: '20', fehlerstrom: '30', charakteristik: 'C', pole: '1+N' },
      { id: 'CO617525', name: 'FI/LS C25A 30mA 1+N', nennstrom: '25', fehlerstrom: '30', charakteristik: 'C', pole: '1+N' }
    ],
    ls: [
      { id: 'BM617106', name: 'LS-Schalter 1P B6A 6kA', nennstrom: '6', charakteristik: 'B', pole: '1' },
      { id: 'BM617110', name: 'LS-Schalter 1P B10A 6kA', nennstrom: '10', charakteristik: 'B', pole: '1' },
      { id: 'BM617113', name: 'LS-Schalter 1P B13A 6kA', nennstrom: '13', charakteristik: 'B', pole: '1' },
      { id: 'BM617116', name: 'LS-Schalter 1P B16A 6kA', nennstrom: '16', charakteristik: 'B', pole: '1' },
      { id: 'BM617120', name: 'LS-Schalter 1P B20A 6kA', nennstrom: '20', charakteristik: 'B', pole: '1' },
      { id: 'BM617125', name: 'LS-Schalter 1P B25A 6kA', nennstrom: '25', charakteristik: 'B', pole: '1' },
      { id: 'BM617132', name: 'LS-Schalter 1P B32A 6kA', nennstrom: '32', charakteristik: 'B', pole: '1' }
    ],
    schuetz: [
      { id: 'LTD00925', name: 'Schütz 9A 230V AC', nennstrom: '9', spulenspannung: '230VAC', kontakte: '3NO' },
      { id: 'LTD01225', name: 'Schütz 12A 230V AC', nennstrom: '12', spulenspannung: '230VAC', kontakte: '3NO' },
      { id: 'LTD01825', name: 'Schütz 18A 230V AC', nennstrom: '18', spulenspannung: '230VAC', kontakte: '3NO' },
      { id: 'LTD02525', name: 'Schütz 25A 230V AC', nennstrom: '25', spulenspannung: '230VAC', kontakte: '3NO' },
      { id: 'LTD03225', name: 'Schütz 32A 230V AC', nennstrom: '32', spulenspannung: '230VAC', kontakte: '3NO' },
      { id: 'LTD04025', name: 'Schütz 40A 230V AC', nennstrom: '40', spulenspannung: '230VAC', kontakte: '3NO' }
    ]
  },

  // WAGO Produkte
  wago: {
    durchgangsklemme: [
      { id: '280-601', name: 'Durchgangsklemme 4mm² grau', querschnitt: '4', farbe: 'grau' },
      { id: '280-901', name: 'Durchgangsklemme 4mm² blau (N)', querschnitt: '4', farbe: 'blau', funktion: 'N' },
      { id: '280-907', name: 'Durchgangsklemme 4mm² grün-gelb (PE)', querschnitt: '4', farbe: 'grün-gelb', funktion: 'PE' },
      { id: '281-601', name: 'Durchgangsklemme 6mm² grau', querschnitt: '6', farbe: 'grau' },
      { id: '281-901', name: 'Durchgangsklemme 6mm² blau (N)', querschnitt: '6', farbe: 'blau', funktion: 'N' },
      { id: '281-907', name: 'Durchgangsklemme 6mm² grün-gelb (PE)', querschnitt: '6', farbe: 'grün-gelb', funktion: 'PE' },
      { id: '282-601', name: 'Durchgangsklemme 10mm² grau', querschnitt: '10', farbe: 'grau' },
      { id: '283-601', name: 'Durchgangsklemme 16mm² grau', querschnitt: '16', farbe: 'grau' },
      { id: '284-601', name: 'Durchgangsklemme 35mm² grau', querschnitt: '35', farbe: 'grau' }
    ],
    etagenklemme: [
      { id: '280-519', name: 'Etagenklemme 4mm² 4-fach LNPE', querschnitt: '4', ebenen: '4', typ: 'LNPE' },
      { id: '280-520', name: 'Etagenklemme 4mm² 4-fach LLPE', querschnitt: '4', ebenen: '4', typ: 'LLPE' },
      { id: '280-521', name: 'Etagenklemme 4mm² 4-fach L-NT-PE', querschnitt: '4', ebenen: '4', typ: 'LNT-PE' },
      { id: '280-549', name: 'Etagenklemme 2.5mm² 4-fach LNPE', querschnitt: '2.5', ebenen: '4', typ: 'LNPE' }
    ],
    verbindungsklemme: [
      { id: '221-412', name: 'Verbindungsklemme 2-fach 0.5-4mm²', querschnitt: '4', pole: '2' },
      { id: '221-413', name: 'Verbindungsklemme 3-fach 0.5-4mm²', querschnitt: '4', pole: '3' },
      { id: '221-415', name: 'Verbindungsklemme 5-fach 0.5-4mm²', querschnitt: '4', pole: '5' },
      { id: '221-612', name: 'Verbindungsklemme 2-fach 0.5-6mm²', querschnitt: '6', pole: '2' },
      { id: '221-613', name: 'Verbindungsklemme 3-fach 0.5-6mm²', querschnitt: '6', pole: '3' },
      { id: '221-615', name: 'Verbindungsklemme 5-fach 0.5-6mm²', querschnitt: '6', pole: '5' }
    ]
  },

  // SIEMENS Produkte
  siemens: {
    logo: [
      { id: '6ED1052-1MD08-0BA1', name: 'LOGO! 12/24RCE', version: '8.3', eingaenge: '8DI', ausgaenge: '4DO' },
      { id: '6ED1052-1FB08-0BA1', name: 'LOGO! 230RCE', version: '8.3', eingaenge: '8DI', ausgaenge: '4DO' },
      { id: '6ED1052-1CC08-0BA1', name: 'LOGO! 24CE', version: '8.3', eingaenge: '8DI', ausgaenge: '4DO' },
      { id: '6ED1055-1MB00-0BA2', name: 'LOGO! DM8 12/24R', version: '8', eingaenge: '4DI', ausgaenge: '4DO' },
      { id: '6ED1055-1NB10-0BA2', name: 'LOGO! DM16 24R', version: '8', eingaenge: '8DI', ausgaenge: '8DO' }
    ],
    schuetz: [
      { id: '3RT2015-1BB41', name: 'Schütz 3kW 24VDC', nennstrom: '7', spulenspannung: '24VDC', kontakte: '3NO' },
      { id: '3RT2015-1AP01', name: 'Schütz 3kW 230VAC', nennstrom: '7', spulenspannung: '230VAC', kontakte: '3NO' },
      { id: '3RT2016-1AP01', name: 'Schütz 4kW 230VAC', nennstrom: '9', spulenspannung: '230VAC', kontakte: '3NO' },
      { id: '3RT2023-1AP00', name: 'Schütz 4kW 230VAC', nennstrom: '9', spulenspannung: '230VAC', kontakte: '3NO' },
      { id: '3RT2024-1AP00', name: 'Schütz 5.5kW 230VAC', nennstrom: '12', spulenspannung: '230VAC', kontakte: '3NO' },
      { id: '3RT2025-1AP00', name: 'Schütz 7.5kW 230VAC', nennstrom: '17', spulenspannung: '230VAC', kontakte: '3NO' }
    ],
    motorschutz: [
      { id: '3RV2011-1AA10', name: 'Motorschutzschalter 1.1-1.6A', einstellbereich: '1.1-1.6', ausloesezeit: 'Standard' },
      { id: '3RV2011-1BA10', name: 'Motorschutzschalter 1.4-2A', einstellbereich: '1.4-2', ausloesezeit: 'Standard' },
      { id: '3RV2011-1CA10', name: 'Motorschutzschalter 1.8-2.5A', einstellbereich: '1.8-2.5', ausloesezeit: 'Standard' },
      { id: '3RV2011-1DA10', name: 'Motorschutzschalter 2.2-3.2A', einstellbereich: '2.2-3.2', ausloesezeit: 'Standard' },
      { id: '3RV2011-1EA10', name: 'Motorschutzschalter 2.8-4A', einstellbereich: '2.8-4', ausloesezeit: 'Standard' },
      { id: '3RV2011-1FA10', name: 'Motorschutzschalter 3.5-5A', einstellbereich: '3.5-5', ausloesezeit: 'Standard' },
      { id: '3RV2011-1GA10', name: 'Motorschutzschalter 4.5-6.3A', einstellbereich: '4.5-6.3', ausloesezeit: 'Standard' },
      { id: '3RV2011-1HA10', name: 'Motorschutzschalter 5.5-8A', einstellbereich: '5.5-8', ausloesezeit: 'Standard' },
      { id: '3RV2011-1JA10', name: 'Motorschutzschalter 7-10A', einstellbereich: '7-10', ausloesezeit: 'Standard' }
    ]
  },

  // EATON Produkte
  eaton: {
    schuetz: [
      { id: 'DILM7-10', name: 'Schütz 3kW 230VAC', nennstrom: '7', spulenspannung: '230VAC', kontakte: '3NO+1NO' },
      { id: 'DILM9-10', name: 'Schütz 4kW 230VAC', nennstrom: '9', spulenspannung: '230VAC', kontakte: '3NO+1NO' },
      { id: 'DILM12-10', name: 'Schütz 5.5kW 230VAC', nennstrom: '12', spulenspannung: '230VAC', kontakte: '3NO+1NO' },
      { id: 'DILM17-10', name: 'Schütz 7.5kW 230VAC', nennstrom: '17', spulenspannung: '230VAC', kontakte: '3NO+1NO' },
      { id: 'DILM25-10', name: 'Schütz 11kW 230VAC', nennstrom: '25', spulenspannung: '230VAC', kontakte: '3NO+1NO' },
      { id: 'DILM32-10', name: 'Schütz 15kW 230VAC', nennstrom: '32', spulenspannung: '230VAC', kontakte: '3NO+1NO' }
    ],
    motorschutz: [
      { id: 'PKZM0-1', name: 'Motorschutzschalter 0.63-1A', einstellbereich: '0.63-1', ausloesezeit: 'Standard' },
      { id: 'PKZM0-1.6', name: 'Motorschutzschalter 1-1.6A', einstellbereich: '1-1.6', ausloesezeit: 'Standard' },
      { id: 'PKZM0-2.5', name: 'Motorschutzschalter 1.6-2.5A', einstellbereich: '1.6-2.5', ausloesezeit: 'Standard' },
      { id: 'PKZM0-4', name: 'Motorschutzschalter 2.5-4A', einstellbereich: '2.5-4', ausloesezeit: 'Standard' },
      { id: 'PKZM0-6.3', name: 'Motorschutzschalter 4-6.3A', einstellbereich: '4-6.3', ausloesezeit: 'Standard' },
      { id: 'PKZM0-10', name: 'Motorschutzschalter 6.3-10A', einstellbereich: '6.3-10', ausloesezeit: 'Standard' }
    ],
    m22: [
      { id: 'M22-D-G', name: 'Drucktaster grün flach', farbe: 'grün', funktion: 'Taster' },
      { id: 'M22-D-R', name: 'Drucktaster rot flach', farbe: 'rot', funktion: 'Taster' },
      { id: 'M22-D-S', name: 'Drucktaster schwarz flach', farbe: 'schwarz', funktion: 'Taster' },
      { id: 'M22-D-W', name: 'Drucktaster weiß flach', farbe: 'weiß', funktion: 'Taster' },
      { id: 'M22-D-Y', name: 'Drucktaster gelb flach', farbe: 'gelb', funktion: 'Taster' },
      { id: 'M22-DL-G', name: 'Leuchtdrucktaster grün', farbe: 'grün', funktion: 'Leuchtaster' },
      { id: 'M22-DL-R', name: 'Leuchtdrucktaster rot', farbe: 'rot', funktion: 'Leuchtaster' },
      { id: 'M22-DL-W', name: 'Leuchtdrucktaster weiß', farbe: 'weiß', funktion: 'Leuchtaster' },
      { id: 'M22-L-G', name: 'Meldeleuchte grün', farbe: 'grün', funktion: 'Meldeleuchte' },
      { id: 'M22-L-R', name: 'Meldeleuchte rot', farbe: 'rot', funktion: 'Meldeleuchte' },
      { id: 'M22-L-Y', name: 'Meldeleuchte gelb', farbe: 'gelb', funktion: 'Meldeleuchte' },
      { id: 'M22-L-W', name: 'Meldeleuchte weiß', farbe: 'weiß', funktion: 'Meldeleuchte' },
      { id: 'M22-WRK', name: 'Wahltaster 2-Stell rastend', farbe: 'schwarz', funktion: 'Wahlschalter' },
      { id: 'M22-WRK3', name: 'Wahltaster 3-Stell rastend', farbe: 'schwarz', funktion: 'Wahlschalter' },
      { id: 'M22-PV', name: 'Not-Aus-Taster', farbe: 'rot/gelb', funktion: 'Not-Aus' },
      { id: 'M22-PVT', name: 'Not-Aus-Taster mit Schlüssel', farbe: 'rot/gelb', funktion: 'Not-Aus' }
    ]
  },

  // ELTAKO Produkte
  eltako: {
    dimmer: [
      { id: 'EUD61NPN-230V', name: 'Universal-Dimmer 400W', leistung: '400', dimmverfahren: 'Phasenanschnitt' },
      { id: 'EUD61M-UC', name: 'Universal-Dimmer 300W', leistung: '300', dimmverfahren: 'Universal' },
      { id: 'EUD61NPN-UC', name: 'Universal-Dimmer 400W UC', leistung: '400', dimmverfahren: 'Universal' },
      { id: 'FUD61NPN-230V', name: 'Funk-Dimmer 400W', leistung: '400', dimmverfahren: 'Funk' }
    ],
    stromstoss: [
      { id: 'ES12-110-UC', name: 'Stromstoßschalter 1S 16A', nennstrom: '16', kontakte: '1NO' },
      { id: 'ES12-200-UC', name: 'Stromstoßschalter 2S 16A', nennstrom: '16', kontakte: '2NO' },
      { id: 'ES12Z-200-UC', name: 'Stromstoßschalter 2S 16A Zentral', nennstrom: '16', kontakte: '2NO' },
      { id: 'ESR12NP-UC', name: 'Stromstoßschalter 1S 16A electronic', nennstrom: '16', kontakte: '1NO' }
    ],
    treppenlicht: [
      { id: 'TLZ61NP-230V', name: 'Treppenlicht-Zeitschalter 16A', nennstrom: '16', zeitbereich: '0.5-20min' },
      { id: 'TLZ12-8-230V', name: 'Treppenlicht-Zeitschalter 8A', nennstrom: '8', zeitbereich: '0.5-10min' },
      { id: 'NLZ61NP-230V', name: 'Nachlaufschalter 16A', nennstrom: '16', zeitbereich: '0.5-12min' }
    ]
  },

  // HOMEMATIC IP Produkte
  homematic: {
    wired: [
      { id: 'HmIPW-DRS4', name: 'Schaltaktor 4-fach', typ: 'Schaltaktor', kanaele: '4' },
      { id: 'HmIPW-DRS8', name: 'Schaltaktor 8-fach', typ: 'Schaltaktor', kanaele: '8' },
      { id: 'HmIPW-DRD3', name: 'Dimmaktor 3-fach', typ: 'Dimmer', kanaele: '3' },
      { id: 'HmIPW-DRBL4', name: 'Jalousie-/Rolladenaktor 4-fach', typ: 'Jalousie', kanaele: '4' },
      { id: 'HmIPW-DRI32', name: 'Eingangsmodul 32-fach', typ: 'Eingang', kanaele: '32' },
      { id: 'HmIPW-DRI16', name: 'Eingangsmodul 16-fach', typ: 'Eingang', kanaele: '16' },
      { id: 'HmIPW-DRAP', name: 'Access Point Wired', typ: 'Gateway', kanaele: '1' },
      { id: 'HmIPW-FAL230-C6', name: 'Fußbodenheizungsaktor 6-fach', typ: 'Heizung', kanaele: '6' },
      { id: 'HmIPW-FAL230-C10', name: 'Fußbodenheizungsaktor 10-fach', typ: 'Heizung', kanaele: '10' },
      { id: 'HmIPW-FAL24-C6', name: 'Fußbodenheizungsaktor 24V 6-fach', typ: 'Heizung', kanaele: '6' },
      { id: 'HmIPW-FAL24-C10', name: 'Fußbodenheizungsaktor 24V 10-fach', typ: 'Heizung', kanaele: '10' }
    ],
    funk: [
      { id: 'HmIP-FSM', name: 'Schalt-Mess-Aktor', typ: 'Schaltaktor', kanaele: '1' },
      { id: 'HmIP-FSM16', name: 'Schalt-Mess-Aktor 16A', typ: 'Schaltaktor', kanaele: '1' },
      { id: 'HmIP-FDT', name: 'Dimmaktor Unterputz', typ: 'Dimmer', kanaele: '1' },
      { id: 'HmIP-FBL', name: 'Jalousienaktor Unterputz', typ: 'Jalousie', kanaele: '1' },
      { id: 'HmIP-FROLL', name: 'Rollladenaktor Unterputz', typ: 'Rollladen', kanaele: '1' },
      { id: 'HmIP-MOD-RC8', name: 'Schaltmodul 8-fach', typ: 'Schaltaktor', kanaele: '8' },
      { id: 'HmIP-MOD-OC8', name: 'Open Collector Modul 8-fach', typ: 'Open Collector', kanaele: '8' }
    ]
  },

  // FRONIUS Produkte
  fronius: {
    smartmeter: [
      { id: 'SM63A-3', name: 'Smart Meter 63A-3 (direkt)', messbereich: '63A', schnittstelle: 'Modbus RTU', messart: 'direkt' },
      { id: 'SM50kA-3', name: 'Smart Meter TS 65A-3 (direkt)', messbereich: '65A', schnittstelle: 'Modbus RTU', messart: 'direkt' },
      { id: 'SM-TS-100A-1', name: 'Smart Meter TS 100A-1 (Wandler)', messbereich: '100A', schnittstelle: 'Modbus RTU', messart: 'wandler' },
      { id: 'SM-TS-5kA-3', name: 'Smart Meter TS 5kA-3 (Wandler)', messbereich: '5000A', schnittstelle: 'Modbus RTU', messart: 'wandler' },
      { id: 'SM-TS-FLEX', name: 'Smart Meter TS Flex (Rogowski)', messbereich: '4000A', schnittstelle: 'Modbus RTU', messart: 'rogowski' }
    ]
  },

  // SHELLY Produkte
  shelly: [
    { id: 'Shelly-Pro-4PM', name: 'Shelly Pro 4PM', typ: 'Schaltaktor', kanaele: '4' },
    { id: 'Shelly-Pro-2PM', name: 'Shelly Pro 2PM', typ: 'Schaltaktor', kanaele: '2' },
    { id: 'Shelly-Pro-1PM', name: 'Shelly Pro 1PM', typ: 'Schaltaktor', kanaele: '1' },
    { id: 'Shelly-Pro-EM-50', name: 'Shelly Pro EM-50', typ: 'Energiemessung', kanaele: '2' },
    { id: 'Shelly-Pro-3EM', name: 'Shelly Pro 3EM', typ: 'Energiemessung', kanaele: '3' },
    { id: 'Shelly-Pro-Dimmer-2PM', name: 'Shelly Pro Dimmer 2PM', typ: 'Dimmer', kanaele: '2' }
  ],

  // KOSTAL Produkte
  kostal: {
    smartmeter: [
      { id: 'KSEM', name: 'KOSTAL Smart Energy Meter', messbereich: '63A', schnittstelle: 'Modbus' }
    ]
  },

  // E3DC Produkte
  e3dc: {
    system: [
      { id: 'S10-E-PRO', name: 'S10 E PRO Hauskraftwerk', typ: 'Speicher' },
      { id: 'S10-X', name: 'S10 X Hauskraftwerk', typ: 'Speicher' }
    ]
  },

  // Janitza Produkte
  janitza: [
    { id: 'UMG96RM', name: 'UMG 96RM Energiemessgerät', typ: 'Multimeter' },
    { id: 'UMG509', name: 'UMG 509 Energiemessgerät', typ: 'Multimeter' },
    { id: 'UMG604', name: 'UMG 604 Energiemessgerät', typ: 'Multimeter' }
  ],

  // Spelsberg Verteiler
  spelsberg: {
    verteiler: [
      { id: 'AK12', name: 'AK 12 Unterputz-Verteiler', reihen: '1', teProReihe: '12', schutzart: 'IP30' },
      { id: 'AK24', name: 'AK 24 Unterputz-Verteiler', reihen: '2', teProReihe: '12', schutzart: 'IP30' },
      { id: 'AK36', name: 'AK 36 Unterputz-Verteiler', reihen: '3', teProReihe: '12', schutzart: 'IP30' },
      { id: 'AK48', name: 'AK 48 Unterputz-Verteiler', reihen: '4', teProReihe: '12', schutzart: 'IP30' },
      { id: 'AK14', name: 'AK 14 Unterputz-Verteiler', reihen: '1', teProReihe: '14', schutzart: 'IP30' },
      { id: 'AK28', name: 'AK 28 Unterputz-Verteiler', reihen: '2', teProReihe: '14', schutzart: 'IP30' },
      { id: 'AK42', name: 'AK 42 Unterputz-Verteiler', reihen: '3', teProReihe: '14', schutzart: 'IP30' },
      { id: 'AK56', name: 'AK 56 Unterputz-Verteiler', reihen: '4', teProReihe: '14', schutzart: 'IP30' }
    ]
  }
};

export default products;
